export default __webpack_public_path__ + "static/media/about-us.cff37766.jpeg";